<template>
  <div class="flex min-h-screen bg-gray-50">
    <Head title="Login" />

    <!-- Left Side - Logo Section -->
    <div class="hidden w-1/2 items-center justify-center lg:flex" style="background: linear-gradient(135deg, #0891b2 0%, #0e7490 100%);">
      <div class="px-12 text-center">
        <img
          src="@/images/components/cmslogo-new.png"
          alt="CMS Logo"
          class="mx-auto mb-8 h-32 w-auto"
        >
        <h2 class="text-3xl font-bold text-white">
          CMS Code
        </h2>
        <p class="mt-4 text-lg text-cyan-100">
          System zarządzania treścią
        </p>
      </div>
    </div>

    <!-- Right Side - Login Form -->
    <div class="flex w-full items-center justify-center px-6 py-12 lg:w-1/2">
      <div class="w-full max-w-md">
        <!-- Mobile Logo -->
        <div class="mb-8 flex justify-center lg:hidden">
          <img
            src="@/images/components/cmslogo-new.png"
            alt="CMS Logo"
            class="h-20 w-auto"
          >
        </div>

        <div class="rounded-2xl bg-white px-8 py-10 shadow-xl sm:px-10">
          <flash-messages />

          <div class="mb-8">
            <h1 class="text-3xl font-bold text-gray-900">
              Zaloguj się
            </h1>
            <p class="mt-2 text-sm text-gray-600">
              Wprowadź swoje dane, aby uzyskać dostęp do panelu
            </p>
          </div>

          <form
            class="space-y-6"
            @submit.prevent="form.post($routes.user_session())"
          >
            <text-input
              v-model="form.user.email"
              label="Email"
              type="email"
              autofocus
              autocapitalize="off"
              autocomplete="email"
            />

            <text-input
              v-model="form.user.password"
              label="Hasło"
              type="password"
              autocomplete="current-password"
            />

            <div class="flex items-center justify-between">
              <label class="flex select-none items-center" for="remember">
                <input
                  id="remember"
                  v-model="form.user.remember_me"
                  class="mr-2 h-4 w-4 rounded border-gray-300 text-cyan-600 focus:ring-cyan-500"
                  type="checkbox"
                >
                <span class="text-sm text-gray-700">Zapamiętaj mnie</span>
              </label>
            </div>

            <loading-button
              :loading="form.processing"
              class="w-full rounded-lg px-6 py-3 text-base font-semibold text-white shadow-lg transition-all duration-200 hover:shadow-xl"
              style="background: linear-gradient(135deg, #0891b2 0%, #0e7490 100%);"
              type="submit"
            >
              Zaloguj się
            </loading-button>
          </form>
        </div>

        <p class="mt-6 text-center text-sm text-gray-600">
          © 2026 CMS Code. Wszelkie prawa zastrzeżone.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3';
import Layout from '@/Layouts/Minimal.vue';
import FlashMessages from '@/Shared/FlashMessages.vue';
import LoadingButton from '@/Shared/LoadingButton.vue';
import TextInput from '@/Shared/TextInput.vue';

export default {
  components: {
    Head,
    FlashMessages,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  data() {
    return {
      form: this.$inertia.form({
        user: {
          email: '',
          password: '',
          remember_me: null,
        },
      }),
    };
  },
};
</script>
